import { createContext, RefObject, useContext } from 'react';

export const AppContext = createContext<{
	/** 本地记录的id */
	localConversationId: RefObject<string>;
	conversationTitle: RefObject<string>;
	conversationType: RefObject<string>;
	refreshConversation: RefObject<() => void>;
}>({
	localConversationId: null,
	conversationTitle: null,
	conversationType: null,
	refreshConversation: null,
});

export const useAppContext = () => useContext(AppContext);
